<div class="main" style="font-family: Noto Sans JP;">
  <div class="top-indicator">
    <span style="color: #7a7a7a; cursor: pointer;" (click)="onClickVessels()">Vessels&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;</span>
    <span style="color: #0a4e6b; font-weight: bold;">{{ vesselForm.value.name }}</span>
  </div>
  <mat-tab-group style="margin-top: 30px;">
    <mat-tab label='{{ "vesselDetails" | translate }}'>
      <div>
        <form [formGroup]="vesselForm" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="edit-btn-area">
            <button type="button" (click)="onClose()" class="back-btn">{{'back' | translate}}</button>
            <div class="action-buttons">
              <button *ngIf="!isEditMode && !auth.isYakuin" class="primary-action-btn" (click)="isEditMode = true">
                {{ "edit" | translate }}
              </button>
              <button *ngIf="isEditMode && !auth.isYakuin" class="secondary-action-btn" (click)="isEditMode = false">
                Cancel
              </button>
              <button *ngIf="isEditMode && !auth.isYakuin" type="submit" class="primary-action-btn submit">{{'save' | translate}}</button>
            </div>
          </div>
      
          <div class="content" class="scrollable-section" [ngClass]="{'edit-mode-styles': isEditMode}">
            <div class="image-container" *ngIf="isEditMode">
              <div class="img-upload">
                <label>
                  <img [src]="selectedImage" alt="!" style="cursor: pointer;" [ngClass]="{'curved-image': hasImage}">
                  <input type="file" id="avatar" accept="image/png" style="cursor: pointer;" (change)="onSelect($event)" name="avatar" class="file-input"/>
                </label>
              </div>
              <label class="upload-label">{{'uploadVesselPhoto'|translate}}</label>
            </div>

            <div *ngIf="!isEditMode">
              <img [src]="selectedImage" *ngIf="hasImage" style="width: 300px;" alt="Vessel image"/>
              <div *ngIf="!hasImage">{{ 'vesselNoImage' | translate }}</div>
            </div>
            <br>

            <mat-expansion-panel style="background-color: rgba(0,0,0,0)" [expanded]="true">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'vesselInformation'|translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="detail-grid detail-panel-container">
                  <div class="detail-item">
                    <div class="detail-label">{{ 'vesselName'|translate }}</div>
                    <div class="details">{{ vesselForm.get('name')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'otherName'|translate }}</div>
                    <div class="details">{{ vesselForm.get('otherName')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'imo'|translate }}</div>
                    <div class="details">{{ vesselForm.get('imo')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'vesselNumber'|translate }}</div>
                    <div class="details">{{ vesselForm.get('vesselNumber')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'vesselType'|translate }}</div>
                    <div class="details">{{ vesselForm.get('vesselType')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'shipType'|translate }}</div>
                    <div class="details">{{ vesselForm.get('shipType')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'builtYear'|translate }}</div>
                    <div class="details">{{ vesselForm.get('builtYear')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'callSign'|translate }}</div>
                    <div class="details">{{ vesselForm.get('callsign')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'hotelPower'|translate }}</div>
                    <div class="details">{{ vesselForm.get('hotelPower')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'numOfThrusters'|translate }}</div>
                    <div class="details">{{ vesselForm.get('NoThruster')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'numOfCrane'|translate }}</div>
                    <div class="details">{{ vesselForm.get('NoCrane')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'numOfLeg'|translate }}</div>
                    <div class="details">{{ vesselForm.get('NoLeg')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'numOfMainEngines'|translate }}</div>
                    <div class="details">{{ vesselForm.get('NoME')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'firstClassificationSociety'|translate }}</div>
                    <div class="details">{{ vesselForm.get('firstClass')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'secondClassificationSociety'|translate }}</div>
                    <div class="details">{{ vesselForm.get('secondClass')?.value || '-' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">{{ 'iEdgeDevice' | translate }}</div>
                    <div class="details">{{ (vesselForm.get("isEdge")?.value == 1 ? "yes" : "no") | translate }}</div>
                  </div>
                </div>
              </div>
              <div *ngIf="isEditMode">
                <div class="field-class">
                  <span class="field-label">*{{ 'vesselName'|translate }}</span>
                  <input type="text" class="input-field" matInput required id="name" [placeholder]="'enterVesselName' | translate" formControlName="name">
                  <div *ngIf="vesselForm.get('name')?.invalid && vesselForm.get('name')?.touched" class="error-message">
                    <div *ngIf="vesselForm.get('name')?.hasError('required')">{{ 'fieldRequired' | translate }}</div>
                  </div>
                </div>
                <div class="field-class">
                  <span class="field-label">{{'otherName'|translate}}</span>
                  <input type="text" class="input-field" matInput id="otherName" [placeholder]="'enterOtherName' | translate" formControlName="otherName">
                </div>
                <div class="field-class">
                  <span class="field-label">{{'imo'|translate}}</span>
                  <input type="text" class="input-field" matInput id="imo" [placeholder]="'enterImo' | translate" formControlName="imo">
                </div>
                <div class="field-class">
                  <span class="field-label">{{'vesselNumber'|translate}}</span>
                  <input type="text" class="input-field" matInput id="vesselNumber" [placeholder]="'enterVesselNumber' | translate" formControlName="vesselNumber">
                </div>
                <div class="field-class">
                  <span class="field-label">{{'vesselType'|translate}}</span>
                  <mat-select class="select-field" formControlName="vesselType" #singleSelect [compareWith]="compareVesselTypes" [placeholder]="'selectVesselType' | translate">
                    <mat-option  *ngFor="let types of vesselTypes" [value]="types.type">{{types.type}}</mat-option>
                  </mat-select>
                </div>
                <div class="field-class">
                  <span class="field-label">{{'shipType'|translate}}</span>
                  <input matInput type="text" class="input-field" id="shipType" [placeholder]="'enterShipType' | translate" formControlName="shipType">
                </div>
                <div class="field-class">
                  <span class="field-label">{{'builtYear'|translate}}</span>
                  <input type="text" class="input-field" matInput id="builtYear" [placeholder]="'enterBuiltYear' | translate" formControlName="builtYear">
                </div>
                <div class="field-class">
                  <span class="field-label">{{'callSign'|translate}}</span>
                  <input type="text" class="input-field" matInput id="callsign" [placeholder]="'enterCallSign' | translate" formControlName="callsign">
                </div>
                <div class="field-class">
                  <span class="field-label">{{'hotelPower'|translate}}</span>
                  <input type="text" class="input-field" matInput id="hotelPower" [placeholder]="'enterHotelPower' | translate" formControlName="hotelPower" >
                </div>
                <div class="field-class">
                  <span class="field-label">{{'numOfThrusters'|translate}}</span>
                  <input type="text" class="input-field" matInput id="NoThruster" [placeholder]="'enterNoThrusters' | translate" formControlName="NoThruster">
                </div>
                <div class="field-class">
                  <span class="field-label">{{'numOfCrane'|translate}}</span>
                  <input type="text" class="input-field" matInput id="NoCrane" [placeholder]="'enterNoCrane' | translate" formControlName="NoCrane">
                </div>
                <div class="field-class">
                  <span class="field-label">{{'numOfLeg'|translate}}</span>
                  <input type="text" class="input-field" matInput id="NoLeg" [placeholder]="'enterNoLeg' | translate" formControlName="NoLeg">
                </div>
                <div class="field-class">
                  <span class="field-label">{{'numOfMainEngines'|translate}}</span>
                  <input type="text" class="input-field" matInput id="NoME" [placeholder]="'enterNoMainEngines' | translate" formControlName="NoME">
                </div>
                <div class="field-class">
                  <span class="field-label">{{'firstClassificationSociety'|translate}}</span>
                  <input matInput type="tel" class="input-field" id="firstClass" [matAutocomplete]="auto4" formControlName="firstClass" [placeholder]="'enterFirstClassificationSociety' | translate"> 
                  <mat-autocomplete #auto4="matAutocomplete">
                    <mat-option *ngFor="let type of classificationSocietyType" [value]="type.type">
                      {{ type.type }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
                <div class="field-class">
                  <span class="field-label">{{'secondClassificationSociety'|translate}}</span>
                  <input matInput type="tel" class="input-field" id="secondClass" [matAutocomplete]="auto5" formControlName="secondClass" [placeholder]="'enterSecondClassificationSociety' | translate">    
                  <mat-autocomplete #auto5="matAutocomplete">
                    <mat-option *ngFor="let type of classificationSocietyType" [value]="type.type">
                      {{ type.type }}
                    </mat-option>
                  </mat-autocomplete>   
                </div>
                <div class="field-class">
                  <p style="margin-top: 10px;">
                    <span class="field-label" style="margin-top: 10px; margin-right: 8px;">{{'createiEdgeDevice' | translate}}</span> 
                    <mat-button-toggle-group formControlName="isEdge">
                      <mat-button-toggle [value]="1" >
                        {{ 'yes' | translate }}
                      </mat-button-toggle>
                      <mat-button-toggle [value]="0">
                        {{ 'no' | translate }}
                      </mat-button-toggle>
                    </mat-button-toggle-group>
                  </p>
                </div>
              </div>
            </mat-expansion-panel>
            <hr class="styled-line"> 
              <!-- ID Information -->
            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'idInfo' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'ownerId'|translate }}</span>
                  <span class="details-content">{{ getCompanyName(vesselForm.get('owner_id')?.value) }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'managerId'|translate }}</span>
                  <span class="details-content">{{ getCompanyName(vesselForm.get('manager_id')?.value) }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'exOwnerId'|translate }}</span>
                  <span class="details-content">{{ getCompanyName(vesselForm.get('exowner_id')?.value) }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'exManagerId'|translate }}</span>
                  <span class="details-content">{{ getCompanyName(vesselForm.get('exmanager_id')?.value) }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'builderId'|translate }}</span>
                  <span class="details-content">{{ getCompanyName(vesselForm.get('builder_id')?.value) }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'maintainerId'|translate }}</span>
                  <span class="details-content">{{ getCompanyName(vesselForm.get('maintener_id')?.value) }}</span>
                </div>
              </div>
              <div *ngIf="isEditMode">
                <div class="field-class">
                  <span class="field-label">* {{'ownerId'|translate}}</span>
                  <mat-select class="select-field" formControlName="owner_id" #singleSelect (selectionChange)="ownerSelection($event)" [placeholder]="'selectCompany' | translate" required>
                    <input type="text" (input)="filterCompany($event, 'owner')" id="owner_search" class="searches" [placeholder]="'searchByName' | translate">
                    <mat-option *ngFor="let company of ownerList" [value]="company.id">{{company.name}}</mat-option>
                  </mat-select>
                </div>
                <div class="field-class">
                  <span class="field-label">* {{'managerId'|translate}}</span>
                  <mat-select class="select-field" formControlName="manager_id" #singleSelect (selectionChange)="managerSelection($event)" [placeholder]="'selectCompany' | translate" required>
                    <input type="text" (input)="filterCompany($event, 'manager')" id="manager_search" class="searches" [placeholder]="'searchByName' | translate">
                    <mat-option *ngFor="let company of managerList" [value]="company.id">{{company.name}}</mat-option>
                  </mat-select>
                </div>
                <div class="field-class">
                  <span class="field-label">{{'exOwnerId'|translate}}</span>
                  <mat-select class="select-field" formControlName="exowner_id" #singleSelect (selectionChange)="exownerSelection($event)" [placeholder]="'selectCompany' | translate">
                    <input type="text" (input)="filterCompany($event, 'exowner')" id="exowner_search" class="searches" [placeholder]="'searchByName' | translate">
                    <mat-option *ngFor="let company of exownerList" [value]="company.id">{{company.name}}</mat-option>
                  </mat-select>
                </div>
                <div class="field-class">
                  <span class="field-label">{{'exManagerId'|translate}}</span>
                  <mat-select class="select-field" formControlName="exmanager_id" #singleSelect (selectionChange)="exmanagerSelection($event)" [placeholder]="'selectCompany' | translate">
                    <input type="text" (input)="filterCompany($event, 'exmanager')" id="exmanager_search" class="searches" [placeholder]="'searchByName' | translate">
                    <mat-option *ngFor="let company of exmanagerList" [value]="company.id">{{company.name}}</mat-option>
                  </mat-select>
                </div>
                <div class="field-class">
                  <span class="field-label">{{'builderId'|translate}}</span>
                  <mat-select class="select-field" formControlName="builder_id" #singleSelect (selectionChange)="builderSelection($event)" [placeholder]="'selectCompany' | translate">
                    <input type="text" (input)="filterCompany($event, 'builder')" id="builder_search" class="searches" [placeholder]="'searchByName' | translate">
                    <mat-option *ngFor="let company of builderList" [value]="company.id">{{company.name}}</mat-option>
                  </mat-select>
                </div>
                <div class="field-class">
                  <span class="field-label">{{'maintainerId'|translate}}</span>
                  <mat-select class="select-field" formControlName="maintener_id" #singleSelect (selectionChange)="maintainerSelection($event)" [placeholder]="'selectCompany' | translate">
                    <input type="text" (input)="filterCompany($event, 'maintainer')" id="maintainer_search" class="searches" [placeholder]="'searchByName' | translate">
                    <mat-option *ngFor="let company of maintainerList" [value]="company.id">{{company.name}}</mat-option>
                  </mat-select>
                </div>
              </div>
            </mat-expansion-panel>
            <hr class="styled-line">
            <!-- Vessel Warranty Information -->
            <mat-expansion-panel style="background-color: rgba(0,0,0,0)"> 
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'vwarrantyInfo' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'vesselWarrantyStartDate'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('vesselWarrantyStartDate')?.value?.slice(0, 10) }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'vesselWarrantyBaseExpDate'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('vesselWarrantyBaseExpDate')?.value?.slice(0, 10) }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'vesselWarrantyExtExpDate'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('vesselWarrantyExtExpDate')?.value?.slice(0, 10) }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'vesselWarrantyExpDate'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('vesselWarrantyExpDate')?.value?.slice(0, 10) }}</span>
                </div>
              </div>
              <div *ngIf="isEditMode">
                <div class="field-class">
                  <span class="field-label">*{{'vesselWarrantyStartDate'|translate}}</span>
                  <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="vesselWarrantyStartDate" [placeholder]="'enterDate' | translate" [required]="true" [autoFocus] = "false"></p-inputMask>
                  <div *ngIf="vesselForm.get('vesselWarrantyStartDate')?.invalid && vesselForm.get('vesselWarrantyStartDate')?.touched" class="error-message">
                    <div *ngIf="vesselForm.get('vesselWarrantyStartDate')?.hasError('required')">{{ 'fieldRequired' | translate }}</div>
                  </div>     
                </div>
                <div class="field-class">
                  <span class="field-label">*{{'vesselWarrantyBaseExpDate'|translate}}</span>
                  <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="vesselWarrantyBaseExpDate" [placeholder]="'enterDate' | translate" [required]="true" [autoFocus] = "false"></p-inputMask>
                  <div *ngIf="vesselForm.get('vesselWarrantyBaseExpDate')?.invalid && vesselForm.get('vesselWarrantyBaseExpDate')?.touched" class="error-message">
                    <div *ngIf="vesselForm.get('vesselWarrantyBaseExpDate')?.hasError('required')">{{ 'fieldRequired' | translate }}</div>
                  </div> 
                </div>
                <div class="field-class">
                  <span class="field-label">*{{'vesselWarrantyExtExpDate'|translate}}</span>
                  <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="vesselWarrantyExtExpDate" [placeholder]="'enterDate' | translate" [required]="true" [autoFocus] = "false"></p-inputMask>
                  <div *ngIf="vesselForm.get('vesselWarrantyExtExpDate')?.invalid && vesselForm.get('vesselWarrantyExtExpDate')?.touched" class="error-message">
                    <div *ngIf="vesselForm.get('vesselWarrantyExtExpDate')?.hasError('required')">{{ 'fieldRequired' | translate }}</div>
                  </div> 
                </div>
                <div class="field-class">
                  <span class="field-label">*{{'vesselWarrantyExpDate'|translate}}</span>
                  <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="vesselWarrantyExpDate" [placeholder]="'enterDate' | translate" [required]="true" [autoFocus] = "false"></p-inputMask>
                  <div *ngIf="vesselForm.get('vesselWarrantyExpDate')?.invalid && vesselForm.get('vesselWarrantyExpDate')?.touched" class="error-message">
                    <div *ngIf="vesselForm.get('vesselWarrantyExpDate')?.hasError('required')">{{ 'fieldRequired' | translate }}</div>
                  </div> 
                </div>
              </div>
            </mat-expansion-panel>  
            <hr class="styled-line"> 
            
            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'me' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'mainEngineTypeCylinderLayout'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('MEEngineType')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'mainEngineTypeAdditionalInfo'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('METype')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOfDG'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('NoDG')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOfShaftGenerators'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('NoSG')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'cylinderBoreDiameter'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('bore')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'cylinderStrokeLength'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('stroke')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'cylinder'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cylinder')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'engineStrokeCycle'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cycle')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'mainEngineMaxKW'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('meMaxKw')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'mainEngineMaxRPM'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('meMaxRpm')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'mainEngineMinRPM'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('meMinRpm')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'normalMainEngineMaxKW'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('normalMeMaxKw')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'normalMainEngineMaxRPM'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('normalMeMaxRpm')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'engineFuelOilUnit'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('engineFoUnit')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'engineFuelOilUnitFactor'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('engineFoUnitFactor')?.value }}</span>
                </div>
              </div>
              <div class="content" *ngIf="isEditMode">
                <div class="field-class" >
                  <span class="field-label">{{'mainEngineTypeCylinderLayout'|translate}}</span>
                  <mat-select class="select-field" formControlName="MEEngineType" #singleSelect [placeholder]="'selectOption' | translate">
                    <mat-option  *ngFor="let type of engineTypes" [value]="type.type">{{type.type}}</mat-option>
                  </mat-select>
                </div>
                <div class="field-class" >
                  <span class="field-label">{{'mainEngineTypeAdditionalInfo'|translate}}</span>
                  <input type="text" class="input-field" matInput id="METype" [placeholder]="'enterValue' | translate" formControlName="METype">
                </div>
                <div class="field-class-two-column">
                  <div class="field-class-sub-left">
                    <span class="field-label">{{'numOfDG'|translate}}</span>
                    <input type="text" class="input-field" matInput [placeholder]="'enterValue' | translate" formControlName="NoDG"> 
                  </div>
                  <div class="field-class-sub-right">
                    <span class="field-label">{{'numOfShaftGenerators'|translate}}</span>
                    <input type="text" class="input-field" matInput [placeholder]="'enterValue' | translate" formControlName="NoSG">
                  </div>
                </div>
                <div class="field-class-two-column">
                  <div class="field-class-sub-left">
                    <span class="field-label">{{'cylinderBoreDiameter'|translate}}</span>
                    <input type="text" class="input-field" matInput id="bore" [placeholder]="'enterValue' | translate" formControlName="bore">  
                  </div>
                  <div class="field-class-sub-right">
                    <span class="field-label">{{'cylinderStrokeLength'|translate}}</span>
                    <input type="text" class="input-field" matInput [placeholder]="'enterValue' | translate" id="stroke" formControlName="stroke">
                  </div>
                </div>
                <div class="field-class-two-column">
                  <div class="field-class-sub-left">
                    <span class="field-label">{{'cylinder'|translate}}</span>
                    <input type="text" class="input-field" matInput id="cylinder" [placeholder]="'enterValue' | translate" formControlName="cylinder">  
                  </div>
                  <div class="field-class-sub-right">       
                    <span class="field-label">{{'engineStrokeCycle'|translate}}</span>
                    <input type="text" class="input-field" matInput [placeholder]="'enterValue' | translate" id="cycle" formControlName="cycle">
                  </div>
                </div>
                <div class="field-class">
                  <span class="field-label">{{'mainEngineMaxKW'|translate}}</span>
                  <input matInput type="number" formControlName="meMaxKw" id="meMaxKw" class="input-field" [placeholder]="'enterNumber' | translate">
                </div>
                <div class="field-class-two-column">
                  <div class="field-class-sub-left">
                    <span class="field-label">{{'mainEngineMaxRPM'|translate}}</span>
                    <input matInput type="number" id="meMaxRpm" formControlName="meMaxRpm" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  <div class="field-class-sub-right">
                    <span class="field-label">{{'mainEngineMinRPM'|translate}}</span>
                    <input matInput type="number" id="meMinRpm" formControlName="meMinRpm" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                </div>
                <div class="field-class">
                  <span class="field-label">{{'normalMainEngineMaxKW'|translate}}</span>
                  <input matInput type="number" formControlName="normalMeMaxKw" class="input-field" [placeholder]="'enterNumber' | translate">
                </div>
                <div class="field-class">
                  <span class="field-label">{{'normalMainEngineMaxRPM'|translate}}</span>
                  <input matInput type="number" formControlName="normalMeMaxRpm" class="input-field" [placeholder]="'enterNumber' | translate">
                </div>
                <div class="field-class-two-column">
                  <div class="field-class-sub-left">
                    <span class="field-label">{{'engineFuelOilUnit'|translate}}</span>
                    <input matInput type="text" formControlName="engineFoUnit" class="input-field" [matAutocomplete]="auto7" [placeholder]="'enterValue' | translate" >
                    <mat-autocomplete #auto7="matAutocomplete">
                      <mat-option *ngFor="let type of engineFoUnitType" [value]="type.value">
                        {{ type.type }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                  <div class="field-class-sub-right">
                    <span class="field-label">{{'engineFuelOilUnitFactor'|translate}}</span>
                    <input matInput type="number" formControlName="engineFoUnitFactor" class="input-field" [placeholder]="'enterNumber' | translate" >
                  </div>
                </div>
              </div>           
            </mat-expansion-panel>
            <hr class="styled-line">
  
            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'gen'|translate}}
              </mat-expansion-panel-header> 
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'sgMaxKW'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('sgMaxKw')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'dgMaxKW'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('geMaxKw')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'geFuelOilUnit'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('generatorFoUnit')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'geFuelOilUnitFactor'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('generatorFoUnitFactor')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'sgMaxKW'|translate}}</span>
                      <input matInput type="number" formControlName="sgMaxKw" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'dgMaxKW'|translate}}</span>
                      <input matInput type="number" formControlName="geMaxKw" id="geMaxKw" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'geFuelOilUnit'|translate}}</span>
                      <input matInput type="text" formControlName="generatorFoUnit" class="input-field" [matAutocomplete]="auto7" [placeholder]="'enterValue' | translate" >
                      <mat-autocomplete #auto7="matAutocomplete">
                        <mat-option *ngFor="let type of engineFoUnitType" [value]="type.value">
                          {{ type.type }}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'geFuelOilUnitFactor'|translate}}</span>
                      <input matInput type="number" formControlName="generatorFoUnitFactor" class="input-field" [placeholder]="'enterNumber' | translate" >
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">
  
            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'vesselIdentification' | translate}}
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <div *ngIf="!isEditMode">
                  <div class="details-sec">
                    <span class="details-title">{{ 'exName'|translate }}</span>
                    <span class="details-content">{{ vesselForm.get('exName')?.value }}</span>
                  </div>
                  <div class="details-sec">
                    <span class="details-title">{{ 'mmsi'|translate }}</span>
                    <span class="details-content">{{ vesselForm.get('mmsi')?.value }}</span>
                  </div>
                  <div class="details-sec">
                    <span class="details-title">{{ 'officialNumber'|translate }}</span>
                    <span class="details-content">{{ vesselForm.get('officialNumber')?.value }}</span>
                  </div>
                  <div class="details-sec">
                    <span class="details-title">{{ 'signalLetter'|translate }}</span>
                    <span class="details-content">{{ vesselForm.get('signalLetters')?.value }}</span>
                  </div>
                  <div class="details-sec">
                    <span class="details-title">{{ 'flag'|translate }}</span>
                    <span class="details-content">{{ vesselForm.get('flag')?.value }}</span>
                  </div>
                  <div class="details-sec">
                    <span class="details-title">{{ 'portOfRegistry'|translate }}</span>
                    <span class="details-content">{{ vesselForm.get('portOfRegistry')?.value }}</span>
                  </div>
                </div>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class">
                    <span class="field-label">{{'exName'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="exName" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'mmsi'|translate}}</span>
                    <input matInput id="mmsi" type="text" autocomplete="off" formControlName="mmsi" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'officialNumber'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="officialNumber" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>  
                  <div class="field-class">
                    <span class="field-label">{{'signalLetter'|translate}}</span>
                    <input matInput id="signalLetters" type="text" autocomplete="off" formControlName="signalLetters" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>  
                  <div class="field-class">
                    <span class="field-label">{{'flag'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="flag" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'portOfRegistry'|translate}}</span>
                    <input matInput id="portOfRegistry" type="text" autocomplete="off" formControlName="portOfRegistry" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">
            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'constructionDetails' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'builtPlace'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('builtPlace')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'structuralDesignType'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('structuralDesignType')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'purpose'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('purpose')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'operationalStatus'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('operationalStatus')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class">
                    <span class="field-label">{{'builtPlace'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="builtPlace" id="builtPlace" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'structuralDesignType'|translate}}</span>       
                    <input matInput [matAutocomplete]="auto" formControlName="structuralDesignType" [placeholder]="'enterValue' | translate" class="input-field">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option *ngFor="let option of structuralDesignTypes" [value]="option.type">
                        {{ option.type }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'purpose'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="purpose" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
              
                  <div class="field-class">
                    <span class="field-label">{{'operationalStatus'|translate}}</span>
                    <input matInput id="operationalStatus" [matAutocomplete]="auto1" type="text" autocomplete="off" formControlName="operationalStatus" class="input-field" [placeholder]="'enterValue' | translate">
                    <mat-autocomplete #auto1="matAutocomplete">
                        <mat-option *ngFor="let type of operationalStatus" [value]="type.type">
                            {{ type.type }}
                        </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">
            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'c&notation' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'noCrewMembers'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('NoCrewMembers')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'notation'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('notation')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class">
                    <span class="field-label">{{'noCrewMembers'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="NoCrewMembers" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'notation'|translate}}</span>
                    <input matInput id="notation" type="text" autocomplete="off" formControlName="notation" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">

            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">         
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'milestoneDates' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'steelCuttingDate'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('steelCuttingDate')?.value?.slice(0, 10) }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'keelLayingDate'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('keelLayingDate')?.value?.slice(0, 10) }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'launchDate'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('launchDate')?.value?.slice(0, 10) }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'deliveryDate'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('deliveryDate')?.value?.slice(0, 10) }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">   
                  <div class="field-class">
                    <span class="field-label">{{'steelCuttingDate'|translate}}</span>
                    <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="steelCuttingDate" [placeholder]="'enterDate' | translate"></p-inputMask>
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'keelLayingDate'|translate}}</span>
                    <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="keelLayingDate" [placeholder]="'enterDate' | translate"></p-inputMask>
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'launchDate'|translate}}</span>
                    <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="launchDate" [placeholder]="'enterDate' | translate"></p-inputMask>
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'deliveryDate'|translate}}</span>
                    <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="deliveryDate" [placeholder]="'enterDate' | translate"></p-inputMask>
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">

            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'fuel_con_info' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'meFuelConsumptionRate'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('meFuelConsumptionRate')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'geFuelConsumptionRate'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('geFuelConsumptionRate')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'meFuelConsumptionRate'|translate}}</span>
                      <input matInput type="number" autocomplete="off" formControlName="meFuelConsumptionRate" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'geFuelConsumptionRate'|translate}}</span>
                      <input matInput id="geMaxKw" type="number" autocomplete="off" formControlName="geFuelConsumptionRate" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">

            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'rudder&propInfo' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'noRudders'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('NoRudders')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'rudderType'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('rudderType')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'propellerType'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('propellerType')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'bladeDiameter'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('bladeDiameter')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOfBlades'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('NoBlades')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'minCPPAngle'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('minCPPAngle')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'maxCPPAngle'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('maxCPPAngle')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'noRudders'|translate}}</span>
                      <input matInput type="number" autocomplete="off" formControlName="NoRudders" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'rudderType'|translate}}</span>
                      <input matInput id="rudderType" type="text" [matAutocomplete]="auto2" autocomplete="off" formControlName="rudderType" class="input-field" [placeholder]="'enterValue' | translate">
                      <mat-autocomplete #auto2="matAutocomplete">
                        <mat-option *ngFor="let type of RudderTypes" [value]="type.type">
                          {{ type.type }}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'propellerType'|translate}}</span>
                    <input matInput type="text" [matAutocomplete]="auto3" autocomplete="off" formControlName="propellerType" class="input-field" [placeholder]="'enterValue' | translate">
                    <mat-autocomplete #auto3="matAutocomplete">
                      <mat-option *ngFor="let type of PropellerTypes" [value]="type.type">
                        {{ type.type }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'bladeDiameter'|translate}}</span>
                      <input matInput id="bladeDiameter" type="number" autocomplete="off" formControlName="bladeDiameter" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'numOfBlades'|translate}}</span>
                      <input matInput type="number" autocomplete="off" formControlName="NoBlades" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'minCPPAngle'|translate}}</span>
                      <input matInput id="minCPPAngle" type="number" autocomplete="off" formControlName="minCPPAngle" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'maxCPPAngle'|translate}}</span>
                      <input matInput id="maxCPPAngle" type="number" autocomplete="off" formControlName="maxCPPAngle" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">

            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'vmeasurements' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'noTank'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('NoTank')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'totalLength'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('totalLength')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'waterLineLength'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('waterlineLength')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'lbp'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('LBP')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'width'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('width')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'draft'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('draft')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'mouldedDepth'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('mouldedDepth')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class">
                    <span class="field-label">{{'noTank'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="NoTank" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'totalLength'|translate}}</span>
                      <input matInput id="totalLength" type="number" autocomplete="off"  formControlName="totalLength" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'waterLineLength'|translate}}</span>
                      <input matInput type="number" autocomplete="off" id="waterlineLength" formControlName="waterlineLength" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'lbp'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="LBP" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'width'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="width" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'draft'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="draft" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label"> {{'mouldedDepth'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="mouldedDepth" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">

            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'tonnage' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'netTonnage'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('netTonnage')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'grossTonnage'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('grossTonnage')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'deadWeightTonnage'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('deadweightTonnage')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class">
                    <span class="field-label">{{'netTonnage'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="netTonnage" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'grossTonnage'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="grossTonnage" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'deadWeightTonnage'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="deadweightTonnage" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">
            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'passengerCapacity'|translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'passengerCapacity'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('passengerCapacity')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <label class="infoes"></label>  
                  <div class="field-class">
                    <span class="field-label">{{'passengerCapacity'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="passengerCapacity" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                </div> 
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">

            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'ccapacity' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'bale'|translate }} (m<sup>3</sup>)</span>
                  <span class="details-content">{{ vesselForm.get('cargoBaleM3')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'grain'|translate }} (m<sup>3</sup>)</span>
                  <span class="details-content">{{ vesselForm.get('cargoGrainM3')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'liquid'|translate }} (m<sup>3</sup>)</span>
                  <span class="details-content">{{ vesselForm.get('cargoLiquidM3')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'refrigerated'|translate }} (m<sup>3</sup>)</span>
                  <span class="details-content">{{ vesselForm.get('cargoRefM3')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOf20FeetContainer'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cargoNoTeu')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOf40FeetContainer'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cargoNoFeu')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOfCars'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cargoNoCar')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOfTrucks'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cargoNoTruck')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOfTrailers'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cargoNoTrailer')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOfForklifts'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cargoNoForklift')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOfBulldozers'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cargoNoBulldozer')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOfChassis'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cargoNoChassis')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'numOfTrainCars'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cargoNoTrainCar')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'customizedUnitForCargo'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cargoOtherUnit')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'customizedCapacity'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('cargoOtherCapacity')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'bale'|translate}} (m<sup>3</sup>)</span>
                      <input matInput type="number" autocomplete="off" formControlName="cargoBaleM3" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'grain'|translate}} (m<sup>3</sup>)</span>
                      <input matInput type="number" autocomplete="off" formControlName="cargoGrainM3" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'liquid'|translate}} (m<sup>3</sup>)</span>
                      <input matInput type="number" autocomplete="off" formControlName="cargoLiquidM3" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'refrigerated'|translate}} (m<sup>3</sup>)</span>
                      <input matInput type="number" autocomplete="off" formControlName="cargoRefM3" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'numOf20FeetContainer'|translate}}</span>
                      <input matInput type="number" autocomplete="off" formControlName="cargoNoTeu" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'numOf40FeetContainer'|translate}}</span>
                      <input matInput type="number" autocomplete="off" formControlName="cargoNoFeu" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'numOfCars'|translate}}</span>
                      <input matInput type="number" autocomplete="off" formControlName="cargoNoCar" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'numOfTrucks'|translate}}</span>
                      <input matInput id="waterlineLength" type="number" autocomplete="off" formControlName="cargoNoTruck" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'numOfTrailers'|translate}}</span>
                      <input matInput type="number" autocomplete="off" formControlName="cargoNoTrailer" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'numOfForklifts'|translate}}</span>
                      <input matInput id="waterlineLength" type="number" autocomplete="off" formControlName="cargoNoForklift" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'numOfBulldozers'|translate}}</span>
                      <input matInput type="number" autocomplete="off" formControlName="cargoNoBulldozer" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'numOfChassis'|translate}}</span>
                      <input matInput id="waterlineLength" type="number" autocomplete="off" formControlName="cargoNoChassis" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'numOfTrainCars'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="cargoNoTrainCar" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  <div class="field-class-two-column">
                    <div class="field-class-sub-left">
                      <span class="field-label">{{'customizedUnitForCargo'|translate}}</span>
                      <input matInput type="text" autocomplete="off" formControlName="cargoOtherUnit" class="input-field" [placeholder]="'enterValue' | translate">
                    </div>
                    <div class="field-class-sub-right">
                      <span class="field-label">{{'customizedCapacity'|translate}}</span>
                      <input matInput id="waterlineLength" type="number" autocomplete="off" formControlName="cargoOtherCapacity" class="input-field" [placeholder]="'enterNumber' | translate">
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">

            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'tcapactiy' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'fuelOilDieselOil'|translate }} (m<sup>3</sup>)</span>
                  <span class="details-content">{{ vesselForm.get('tankCapacityFoM3')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'freshWater'|translate }} (m<sup>3</sup>)</span>
                  <span class="details-content">{{ vesselForm.get('tankCapacityFwM3')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'waterBallast'|translate }} (m<sup>3</sup>)</span>
                  <span class="details-content">{{ vesselForm.get('tankCapacityWbM3')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class">
                    <span class="field-label">{{'fuelOilDieselOil'|translate}} (m<sup>3</sup>)</span>
                    <input matInput type="text" autocomplete="off" formControlName="tankCapacityFoM3" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'freshWater'|translate}} (m<sup>3</sup>)</span>
                    <input matInput type="text" autocomplete="off" formControlName="tankCapacityFwM3" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                  <div class="field-class">
                    <span class="field-label">{{'waterBallast'|translate}} (m<sup>3</sup>)</span>
                    <input matInput type="text" autocomplete="off" formControlName="tankCapacityWbM3" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">

            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'additionalDetails' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'bulbousBow'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('bulbousBow')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'meBuiltYear'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('meBuiltYear')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'lw'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('L_w')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'cb'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('C_B')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'etaD'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('eta_D')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'maxSpeedKn'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('maxSpeedKn')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class">
                    <span class="field-label">{{'bulbousBow'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="bulbousBow" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  
                  <div class="field-class">
                    <span class="field-label">{{'meBuiltYear'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="meBuiltYear" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  
                  <div class="field-class">
                    <span class="field-label">{{'lw'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="L_w" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  
                  <div class="field-class">
                    <span class="field-label">{{'cb'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="C_B" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  
                  <div class="field-class">
                    <span class="field-label">{{'etaD'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="eta_D" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div>
                  
                  <div class="field-class">
                    <span class="field-label">{{'maxSpeedKn'|translate}}</span>
                    <input matInput type="number" autocomplete="off" formControlName="maxSpeedKn" class="input-field" [placeholder]="'enterNumber' | translate">
                  </div> 
                </div>
                </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">

            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'sInfo' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'salesRepName'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('salesRepresentativeName')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'salesAddress'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('salesAddress')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'salesEmail'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('salesEmail')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'salesTelephone'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('salesTelephone')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class">
                    <span class="field-label">{{'salesRepName'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="salesRepresentativeName" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>            
                  <div class="field-class">
                    <span class="field-label">{{'salesAddress'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="salesAddress" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>       
                  <div class="field-class">
                    <span class="field-label">{{'salesEmail'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="salesEmail" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>         
                  <div class="field-class">
                    <span class="field-label">{{'salesTelephone'|translate}}</span>
                    <input matInput type="tele" autocomplete="off" formControlName="salesTelephone" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                </div>
            </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">

            <mat-expansion-panel style="background-color: rgba(0,0,0,0)">
              <mat-expansion-panel-header [collapsedHeight]="'80px'" style="color: var(--text-color)">
                {{'sainfo' | translate}}
              </mat-expansion-panel-header>
              <div *ngIf="!isEditMode">
                <div class="details-sec">
                  <span class="details-title">{{ 'salesAgentName'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('salesAgentName')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'salesAgentAddress'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('salesAgentAddress')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'salesAgentEmail'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('salesAgentEmail')?.value }}</span>
                </div>
                <div class="details-sec">
                  <span class="details-title">{{ 'salesAgentTelephone'|translate }}</span>
                  <span class="details-content">{{ vesselForm.get('salesAgentTelephone')?.value }}</span>
                </div>
              </div>
              <ng-template matExpansionPanelContent>
                <div class="content" *ngIf="isEditMode">
                  <div class="field-class">
                    <span class="field-label">{{'salesAgentName'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="salesAgentName" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>            
                  <div class="field-class">
                    <span class="field-label">{{'salesAgentAddress'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="salesAgentAddress" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>       
                  <div class="field-class">
                    <span class="field-label">{{'salesAgentEmail'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="salesAgentEmail" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>         
                  <div class="field-class">
                    <span class="field-label">{{'salesAgentTelephone'|translate}}</span>
                    <input matInput type="text" autocomplete="off" formControlName="salesAgentTelephone" class="input-field" [placeholder]="'enterValue' | translate">
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
            <hr class="styled-line">        
            <br>
            <div class="content" *ngIf="isEditMode">
              <div class="label-class">{{'vessselMappingFileUpload'|translate}}</div>
              <div style="margin-top: 20px;">
                <input type="file" class="file-inputs" (change)="onChange($event)"/>    
                <div *ngIf="file">
                  <section class="file-info">
                    File details:
                    <ul>
                      <li>Name: {{file.name}}</li>
                      <li>Type: {{file.type}}</li>
                      <li>Size: {{file.size}} bytes</li>
                    </ul>
                  </section>    
                  <button (click)="onUpload()" type="button">Upload the file</button>
                  <section [ngSwitch]="status">
                    <p *ngSwitchCase="'uploading'">Uploading...</p>
                    <p *ngSwitchCase="'success'">Done!</p>
                    <p *ngSwitchCase="'fail'">Error!</p>
                    <p *ngSwitchDefault>Waiting to upload...</p>
                  </section>      
                </div> 
              </div>
            </div>
            <br>
            <br>
          </div>
        </form>
      </div>
    </mat-tab>
    <mat-tab label='{{ "subscription" | translate }}'>
      <div style="justify-content: end; display: flex;">
        <div style="display: flex; flex-direction: row;">
          <button type="button" (click)="onClose()" class="cancel">{{'cancel' | translate}}</button>
          <button type="button" (click)="updateSubscription()" class="submit">{{'save' | translate}}</button>
        </div>
      </div>
      <div class="scrollable-section">
        <div class="label-class">{{'subscription'|translate}}</div>
      <div>
        <div style="width: 100px">
          <p-treeSelect
            *ngIf="isTreeReady"
            [options]="primeNgDataset"
            [(ngModel)]="selectedNodes"
            [ngModelOptions]="{standalone: true}"
            class="w-full"
            containerStyleClass="w-full"
            placeholder="Select the item"
            selectionMode="checkbox"
            [metaKeySelection]="false"
            [propagateSelectionUp]="false" 
            [propagateSelectionDown]="false"
            [showClear]="false"
            [filter]="false"
            (onNodeSelect)="onNodeSelect($event)"
            (onNodeUnselect)="onNodeUnselect($event)"  
            display="chip"
          > 
          </p-treeSelect>
          <span *ngIf="isTreeLoading">
            Loading...
          </span>
        </div>
        <br>
        <div style="width: 26.25rem">
          <p-tree class="subscription-tree w-full md:w-26.25rem" 
            [value]="primeNgTreeDataSet" 
            [metaKeySelection]="false"
            [propagateSelectionUp]="false" 
            [propagateSelectionDown]="false"
          ></p-tree>
        </div>
      </div>
      </div>
    </mat-tab>
    <mat-tab label='{{ "deployment" | translate }}'>
    </mat-tab>
    <mat-tab label='{{ "equipment" | translate }}'>
      <button type="button" (click)="onNewEquip()" class="newEquipBtn">
        <div style="margin: auto; font-family: Inter; font-weight: bold;">+ {{'newEquip' | translate}}</div>
      </button>
      <div class="equipTitle">
        {{vesselForm.value.name}}{{'vslEquip' | translate}}
      </div>

      <p-table
        #dt1 
        [value]="equipList" 
        [tableStyle]="" 
        styleClass="p-datatable-striped p-datatable-gridlines"
        dataKey="id"
        [paginator]="true"
        [rows]="20"
        [loading]="equipLoading"
        responsiveLayout="stack" 
        [breakpoint]="'500px'"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [globalFilterFields]="['name','id']"
      >
        <ng-template pTemplate="caption">
          <div style="display: flex; justify-content: space-between;">
            <div>
              <input
                pInputText
                style="float: left; width: 400px; font-size: 14px; background-color: var(--list-bg-color); color: var(--text-color); -webkit-transition: 0s; transition: 0s; padding-top: 8px;"
                type="text"
                placeholder="Search equipment"
                (input)="dt1.filterGlobal($any($event.target).value, 'contains')" 
                class="pl-3 pr-3 border border-gray-300 focus:border-blue-500 h-10 outline-none font-sans text-lg font-light"
              >
              <i class="pi pi-search object-right items-center -ml-6 text-gray-400 mt-3"></i>
            </div>
            <div style="margin-top: 5px; display: flex; gap: 16px;">
              <button 
                style="align-items: center; gap: 1px; display: flex;"
                (click)="sortItems('name', 'asc')"
              >
                <span style="color: #263238; font-size: 14px; font-weight: 400; display: inline-block;">A-Z</span>
                <img style="content: url('../../../../assets/sorting_btn.svg'); display: inline-block;">
              </button>
              <button style="color: #263238; font-size: 14px; margin-right: 36px; font-weight: 400;" (click)="sortItems('lastUpdate', 'desc')">Recent</button>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <div style="display: flex; width: 100%; margin-top: 20px;">
            <div style="width: 20%;">
              <div class="equipListHeader">Equipment Name</div>
              <input
                pInputText
                style="float: left; width: 70%; font-size: 14px; color: var(--text-color); background: transparent; outline: none; border: none; border-bottom: solid 1px #3b5559; padding-top: 10px; padding-left: 10px;"
                type="text"
                placeholder="Contains"
                (input)="dt1.filter($any($event.target).value, 'name', 'contains')" 
                class="focus:border-blue-500 h-8 outline-none font-sans text-lg font-light"
              >
              <img style="content: url('../../../../assets/filter_list.svg'); margin-top: 12px;">
            </div>
            <div style="width: 15%;">
              <div class="equipListHeader">Category</div>
              <div style="font-size: 10px; margin-left: 10px;">Is</div>
              <input
                pInputText
                style="float: left; width: 70%; font-size: 14px; color: var(--text-color); background: transparent; outline: none; border: none; border-bottom: solid 1px #3b5559; padding-top: 8px; padding-left: 10px; height: 25px;"
                type="text"
                placeholder="Any"
                (input)="dt1.filter($any($event.target).value, 'category', 'contains')" 
                class="focus:border-blue-500 outline-none font-sans text-lg font-light"
              >
              <img style="content: url('../../../../assets/filter_list.svg'); margin-top: -3px;">
            </div>
            <div style="width: 15%;">
              <div class="equipListHeader">Model</div>
              <input
                pInputText
                style="float: left; width: 70%; font-size: 14px; color: var(--text-color); background: transparent; outline: none; border: none; border-bottom: solid 1px #3b5559; padding-top: 10px; padding-left: 10px;"
                type="text"
                placeholder="Contains"
                (input)="dt1.filter($any($event.target).value, 'model', 'contains')" 
                class="focus:border-blue-500 h-8 outline-none font-sans text-lg font-light"
              >
              <img style="content: url('../../../../assets/filter_list.svg'); margin-top: 12px;">
            </div>
            <div style="width: 15%;">
              <div class="equipListHeader">Manufacturer</div>
              <input
                pInputText
                style="float: left; width: 70%; font-size: 14px; color: var(--text-color); background: transparent; outline: none; border: none; border-bottom: solid 1px #3b5559; padding-top: 10px; padding-left: 10px;"
                type="text"
                placeholder="Contains"
                (input)="dt1.filter($any($event.target).value, 'manufacturer', 'contains')" 
                class="focus:border-blue-500 h-8 outline-none font-sans text-lg font-light"
              >
              <img style="content: url('../../../../assets/filter_list.svg'); margin-top: 12px;">
            </div>
            <div style="width: 15%;">
              <div class="equipListHeader">Warranty</div>
              <div style="font-size: 10px; margin-left: 10px;">Is</div>
              <input
                pInputText
                style="float: left; width: 70%; font-size: 14px; color: var(--text-color); background: transparent; outline: none; border: none; border-bottom: solid 1px #3b5559; padding-top: 8px; padding-left: 10px; height: 25px;"
                type="text"
                placeholder="Any"
                (input)="dt1.filter($any($event.target).value, 'category', 'contains')" 
                class="focus:border-blue-500 outline-none font-sans text-lg font-light"
              >
              <img style="content: url('../../../../assets/filter_list.svg'); margin-top: -3px;">
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>

        </ng-template>
      </p-table>
    </mat-tab>
    <mat-tab label='{{ "salesInfo" | translate }}'>
    </mat-tab>
  </mat-tab-group>
</div>
  
  